import { useContext } from 'react';

import { XYChartDataContext } from '../context/XYChartData.context.js';

export const useXYChartData = () => {
  const context = useContext(XYChartDataContext);

  if (context === undefined) {
    throw new Error('useXYChartData must be used within a XYChartDataContext');
  }

  return context as Required<XYChartDataContext>;
};
